import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { User } from "../../shared/models/user";
import { UserService } from "../../shared/services/user.service";
import { Role } from "../../shared/models/role";
import { AlertService } from 'app/shared/services/alert.service';
import { AuthService } from 'app/login/services/auth.service';

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.css']
})
export class UserEditComponent implements OnInit {
  private _user:User;
  public passwordChange:string;
  public confirmPassword:string;
  public isSaving:boolean;

  public canArchive:boolean;

  public get User() {
    return this._user;
  }
  public set User(v:User) {
    this._user = v;
  }

  constructor(private userService:UserService, private route:ActivatedRoute
    , private alertService:AlertService, private authService:AuthService) { 
      this.passwordChange = "";
      this.confirmPassword = "";
    this._user = new User();
    this.isSaving = false;
    this.canArchive = true;
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      let userId = params['userId'];
      let editUser = this.userService.getUser(userId);
      let currentUser = this.authService.getCurrentUser();
      Promise.all([editUser, currentUser]).then((results) => {
        let [user, currentUser] = results;
        this._user = user;
        if (user.id == currentUser.id) {
          this.canArchive = false;
        } else if (user.role <= Role.Owner) {
          this.canArchive = false;
        }
      });
      
      // TODO: stephen handle not found user...
    });
  }

  private validateForm() {
    let errors = [];
    // nothing to do here as the passwords don't matter.
    if (!(this.passwordChange && this.confirmPassword)) {
      return errors;
    }
    if (this.passwordChange != this.confirmPassword) {
      errors.push("Your passwords don't match"); 
    }
    let passwordPolicyMsg = "Password must be 8 characters or more, contain at least one number(0-9), one uppercase letter(a-z), and one lowercase letter(A-Z)";
    let password = this.passwordChange;
    if (!password || password.length < 8) {
      errors.push(passwordPolicyMsg);
    }
    else if (!password.match(/[0-9]+/)) {
      errors.push(passwordPolicyMsg);
    }
    else if (!password.match(/[A-Z]+/)) {
      errors.push(passwordPolicyMsg);
    }
    else if (!password.match(/[a-z]+/)) {
      errors.push(passwordPolicyMsg);
    }
    return errors;
  }

  public save() {
    let errors = this.validateForm();
    if (errors.length) {
      this.alertService.error(errors.join("\n"), 3000);
      return;
    }
    if (this.passwordChange.trim() != "") {
      this._user.password = this.passwordChange;
    }
    this.userService.saveUser(this._user).then(response => {
      this.alertService.success("User saved!");
    })
    .catch(error => {
      if (error._code == 'DUP_ENTRY') {
        this.alertService.error(error.message);
      } else {
        this.alertService.error("User failed to save.  Please try again or contact support!");
      }
    });
  }

  public archiveUser() {
    if (confirm("Are you sure you wish to archive this user?")) {
      this.userService.archiveUser(this._user);
    }
  }

  public restoreUser() {
    this.userService.restoreUser(this._user);
  }

  public setUserRole(role:Role) {
    console.log("setting user's role to ", role);
    this._user.role = role;
  }

}




// WEBPACK FOOTER //
// ./src/app/users/user-edit/user-edit.component.ts